import { axiosBase, errorHandler } from "./axios";

const getSubscriptionPlan = (planName: string) => {
  return axiosBase
    .get(`subscriptions/getPlan/${planName}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const createSubscription = (data: any) => {
  return axiosBase
    .post("subscriptions/create", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getSubscriptionStatus = (subscriptionId: string) => {
  return axiosBase
    .get(`subscriptions/status/${subscriptionId}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getSubscriptionSyncStatus = (data: any) => {
  console.log("service:", data);
  
  return axiosBase
    .get(`/subscription-status/sync/${data.tenantId}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getOrderStatus = (orderId: string) => {
  return axiosBase
    .get(`subscriptions/order-status/${orderId}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const syncPlans = () => {
  return axiosBase
    .post("subscriptions/sync-plans")
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getAllPlans = () => {
  return axiosBase
    .get("subscriptions/getAllPlan")
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getUserSubscriptionStatus = () => {
  return axiosBase
    .get("subscriptions/user-status")
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

/* ----------------- Super Admin: Subscription Plan management ---------------- */

const listAdminPlans = (params: any) => {
  return axiosBase
    .get("subscriptions/admin/plans", { params })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const viewAdminPlan = (id: string) => {
  return axiosBase
    .get(`subscriptions/admin/plan/${id}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const createAdminPlan = (data: any) => {
  return axiosBase
    .post("subscriptions/admin/plan", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const updateAdminPlan = ({ id, data }: { id: string; data: any }) => {
  return axiosBase
    .put(`subscriptions/admin/plan/${id}`, data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const deleteAdminPlan = (id: string) => {
  return axiosBase
    .delete(`subscriptions/admin/plan/${id}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

// App route master — feeds the plan form's route dropdown
const getRoutes = () => {
  return axiosBase
    .get("common/routes")
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getInvoice = (invoiceId: string) => {
  return axiosBase
    .get(`subscriptions/getInvoice/${invoiceId}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const getAllInvoices = (data: any) => {
  return axiosBase
    .post("subscriptions/getAllInvoices",  data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const getInvoicePDF = (data: any) => {
  return axiosBase.get("subscriptions/generateInvoice", { 
    params: data,
    responseType: 'blob'
  })
    .then((response) => response)
    .catch((error) => errorHandler(error));
}

const getOverallInvoices = (data: any) => {
  return axiosBase.post("subscriptions/exportOverallList",data, { 
    responseType: 'blob'
  })
    .then((response) => response)
    .catch((error) => errorHandler(error));
}


export const subscriptionService = {
  getSubscriptionPlan,
  createSubscription,
  getSubscriptionStatus,
  getOrderStatus,
  syncPlans,
  getAllPlans,
  getUserSubscriptionStatus,
  listAdminPlans,
  viewAdminPlan,
  createAdminPlan,
  updateAdminPlan,
  deleteAdminPlan,
  getSubscriptionSyncStatus,
  getRoutes,
  getInvoice,
  getAllInvoices,
  getInvoicePDF,
  getOverallInvoices
};
